const jobTips = {
    en: [
        "Do not share confidential or personal data.",
        "Be careful and make sure that the employer is reliable.",
        "Don't pay money to hire or train you."
    ],
    ar: [
        "لا تشارك بيانات سرية أو شخصية.",
        "احذر وتأكد أن جهة التوظيف موثوقة.",
        "لا تقم بدفع المال لتوظيفك أو تدريبك."
    ],
};
const generalTips = {
    en: [
        "Only meet in public places.",
        "Never pay or transfer money in advance.",
        "Inspect the product before you buy it."
    ],
    ar: [
        "اجتمع في الأماكن العامة فقط.",
        "لا تقم بإرسال المال مسبقاً.",
        "قم بتفقد المنتج جيداً قبل شرائه."
    ],
};
const ERROR = {
    en: 'Not Sent',
    ar: 'لم ترسل'
};
const OFFLINE_MESSAGES = {
    en: [
        "Resend",
        "Cancel"
    ],
    ar: [
        "أرسـل",
        "الـغاء"
    ],
};
export { jobTips, generalTips, ERROR, OFFLINE_MESSAGES };
